import styles from "./Input.module.scss";
import cn from "clsx";

export default function InputV2({
  placeholder,
  label,
  value,
  onChange,
  onBlur,
  name,
  error,
  rootClass = null,
  disabled = false,
  id = "inputV2",
}) {
  return (
    <div className={cn(styles.InputV2__root, rootClass)}>
      <label htmlFor={id}>{label}</label>
      <input
        placeholder={placeholder}
        name={name}
        value={value ?? ""}
        onChange={onChange}
        onBlur={onBlur}
        id={id}
        disabled={disabled}
      />
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
}
